angular.module('vastdesk').
  component('tagPixels', {
    bindings: {
      format: '@',
      environment: '@'
    },
    controller: ['$rootScope', function($rootScope) {
      
      var self = this;
      var bodySelector = $('body');

      bodySelector.on('cocoon:after-insert', '#tag_pixels', function() {
        $(this).find('.chosen-select').defaultChosen();

        filterEventPixelsOptions();
      });

      var filterEventPixelsOptions = function() {
        setTimeout(function() {
          const tileOrDisplay = ['tile', 'display'].includes(self.format);
          const selects = $('.tag-pixel-type-select');

          // Toggle visibility of Pixel Type options, only showing valid ones.
          // Visibility depends only on format/environment, so it applies uniformly to every pixel select.

          if (tileOrDisplay) {
            selects.find("option:not([value='AdImpression']):not([value='AdClickThru'])").hide();
          }
          else {
            selects.find("option:not([value='AdImpression']):not([value='AdClickThru'])").show();
          }

          if (self.environment === 'ctv') {
            selects.find("option[value='AdRequest']").hide();
          } else if (!tileOrDisplay) {
            selects.find("option[value='AdRequest']").show();
          }

          if (self.environment === 'dooh') {
            selects.find("option[value='AdClickThru']").hide();
          }
          else {
            // required to show after environment change
            selects.find("option[value='AdClickThru']").show();
          }

          // Clear each pixel's selection when the option it points to has just been
          // hidden above, so a now-invalid value can't survive to submission. This is
          // per-select since it depends on each row's current value.
          selects.each(function() {
            var select = $(this);
            var pixelType = select.find('option:selected').val();

            var invalidCtvPixelType = self.environment === 'ctv' && pixelType === 'AdRequest';
            var invalidTileOrDisplayPixelType = tileOrDisplay && !['AdImpression', 'AdClickThru'].includes(pixelType);
            var invalidDoohPixelType = self.environment === 'dooh' && pixelType === 'AdClickThru';

            if (invalidCtvPixelType || invalidTileOrDisplayPixelType || invalidDoohPixelType) {
              select.val('');
            }
          });

          $('.tag-pixel-type-select').trigger('chosen:updated');
        }, 0);
      };

      bodySelector.on('change', 'input[name$="[environment]"]', function() {
        filterEventPixelsOptions();
      });

      $rootScope.$on('environmentChange', function(e, args) {
        self.environment = args.environment;
        filterEventPixelsOptions();
      });

      $rootScope.$on('formatChanged', function(e, args) {
        self.format = args.format;

        filterEventPixelsOptions();
      });

      this.$onInit = function() {
        setTimeout(function() {
          filterEventPixelsOptions();
        }, 0);
      };
    }]
});
